angular.
module("dx.webapp.class").
controller("DxClassAddStudentsRouteController", function ClassAddStudentsRouteController(
	$routeParams,

	dxApi,
	validationService,

	dxLocalize,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.id = parseInt($routeParams.id, 10);

	// Add from Excel
	self.studentsPasteModel = [];
	self.studentsPasteErrors = [];
	self.studentsAddMessage = null;
	self.studentsAddFeedbackClass = null;
	self.usedStudentEmails = [];
	self.validStudentPaste = false;

	self.onBeforePaste = function onBeforePaste(data) {
		self.studentsPasteErrors = [];
		self.studentsAddMessage = null;
		self.usedStudentEmails = [];
		self.validStudentPaste = true;
		return data;
	};

	self.onValidateEntry = function onValidEntry(rowArray, rowData) {
		var isValid = true;
		rowArray.email = rowArray.email.trim();

		if (!validationService.isEmailValid(rowArray.email)) {
			isValid = false;
			self.studentsPasteErrors.push(dxLocalize.get("PasteFrom.InvalidEmail", rowData.index + 1, rowArray.email));
		}

		if (self.usedStudentEmails.indexOf(rowArray.email) > -1) {
			isValid = false;
			self.studentsPasteErrors.push(dxLocalize.get("PasteFrom.Duplicate", rowData.index + 1, rowArray.email));
		}

		self.usedStudentEmails.push(rowArray.email);

		return isValid;
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			self.studentsPasteErrors.push(
				dxLocalize.get(
					"PasteFrom.InvalidColumnCount.SingularExpected",
					rowData.index + 1,
					rowData.expectedLength,
					rowData.actualLength,
					rowData.source
				)
			);
		}
		self.validStudentPaste = false;
	};

	self.addPastedStudents = function addPastedStudents() {
		if (self.studentsPasteErrors.length || self.inProgress) {
			return;
		}

		self.inProgress = true;
		self.validStudentPaste = false;

		var studentEmails = [];
		for (var i = 0; i < self.studentsPasteModel.length; i++) {
			studentEmails.push(self.studentsPasteModel[i].email);
		}

		dxApi.v1.groups.addMembers(self.id, studentEmails, [403, 404]).then(function success(response) {
			var data = response.data;
			self.studentsAddFeedbackClass = "color-text-success";

			if (data.added.length > 1) {
				self.studentsAddMessage = dxLocalize.get("Feedback.Added.Count.Students", data.added.length);
			} else if (data.added.length === 1) {
				self.studentsAddMessage = dxLocalize.get("Feedback.Added.Single.Student");
			} else {
				// Zero additions
				self.studentsAddFeedbackClass = "color-text-warning";

				self.studentsAddMessage = dxLocalize.get("Feedback.Added.Count.Students", data.added.length);
			}

			for (var j = 0; j < self.studentsPasteModel.length; j++) {
				var studentModel = self.studentsPasteModel[j];
				feedbackGroupAdd(studentModel, data.added, false);
				feedbackGroupAdd(studentModel, data.alreadyAdded, true);
			}

			self.inProgress = false;
		}, function fail(response) {
			var data = response.data;
			self.studentsAddFeedbackClass = "color-text-error";
			if (response.status === 404) {
				self.studentsAddMessage = dxLocalize.get("PasteFrom.DoesNotExist");
			} else {
				self.studentsAddMessage = dxLocalize.get("PasteFrom.SomethingWentWrong");
			}

			for (var j = 0; j < self.studentsPasteModel.length; j++) {
				if (Array.isArray(data.context) && data.context.indexOf(self.studentsPasteModel[j].email) > -1) {
					self.studentsPasteModel[j].notFound = true;
					continue;
				}

				self.studentsPasteModel[j].notAdded = true;
			}

			self.inProgress = false;
		});
	};

	function feedbackGroupAdd(studentModel, feedbackArray, exists) {
		for (var i = 0; i < feedbackArray.length; i++) {
			if (studentModel.email === feedbackArray[i].email) {
				studentModel.name = feedbackArray[i].name;
				if (exists) {
					studentModel.exists = true;
				} else {
					studentModel.new = true;
				}
				break;
			}
		}
	}
});
